import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagChevronLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.46742 7.17082C1.96875 6.17347 2.69399 5 3.80906 5H16.764C17.9003 5 18.9391 5.64201 19.4473 6.65836L21.4473 10.6584C21.8696 11.5029 21.8696 12.4971 21.4473 13.3416L19.4473 17.3416C18.9391 18.358 17.9003 19 16.764 19H3.80906C2.69399 19 1.96875 17.8265 2.46742 16.8292L4.65841 12.4472C4.79917 12.1657 4.79917 11.8343 4.65841 11.5528L2.46742 7.17082ZM4.61808 7L6.44726 10.6584C6.86955 11.5029 6.86955 12.4971 6.44726 13.3416L4.61808 17H16.764C17.1428 17 17.489 16.786 17.6584 16.4472L19.6584 12.4472C19.7992 12.1657 19.7992 11.8343 19.6584 11.5528L17.6584 7.55279C17.489 7.214 17.1428 7 16.764 7H4.61808Z"
	})
});
export default SvgTagChevronLine;
